/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import useForm from '../utils/useForm';
// import VendorService from '../../services/VendorService';
import LenderService from '../../services/LenderService';
import LienHolderService from '../../services/LienHolderService';

const penaltySplitOptions = [
  { value: 0, label: '0%' },
  { value: 0.1, label: '10%' },
  { value: 0.2, label: '20%' },
  { value: 0.3, label: '30%' },
  { value: 0.4, label: '40%' },
  { value: 0.5, label: '50%' },
  { value: 0.6, label: '60%' },
  { value: 0.7, label: '70%' },
  { value: 0.8, label: '80%' },
  { value: 0.9, label: '90%' },
  { value: 1, label: '100%' },
];

const cushionOptions = [
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
];

const useSettingsForm = (onSubmit, values, isLender, lenderId) => {
  const fields = useMemo(
    () => [
      {
        title: 'Settings',
        fields: [
          {
            title: 'Status',
            name: 'status',
            type: 'select',
            readOnly: isLender,
            options: [
              {
                label: 'Active',
                value: 'active',
              },
              {
                label: 'Archived',
                value: 'archived',
              },
              {
                label: 'Paid',
                value: 'paid',
              },
              {
                label: 'Pending',
                value: 'pending',
              },
              {
                label: 'Review',
                value: 'review',
              },
            ],
          },
          {
            title: 'Tax Impound Shortage',
            description:
              'How should Pixel Servicing handle tax impound shortage at the time taxes are due?',
            name: 'pref_tax_impound_shortage',
            type: 'radio',
            options: [
              {
                label:
                  'Notify lender in advance. Lender will decide whether or not to advance funds at that time.',
                value: 'lender_notify',
              },
              {
                label:
                  'Withdraw automatically from lender’s bank account to advance and cover shortage.',
                value: 'lender_advance',
              },
              {
                label: 'Do nothing. Taxes will NOT be paid.',
                value: 'do_nothing',
              },
            ],
          },
          {
            title: 'Insurance Cancellation',
            description:
              'How should Pixel Servicing handle insufficent insurance coverage?',
            name: 'pref_insurance_cancel',
            type: 'radio',
            options: [
              {
                label:
                  'Force place automatically. Payment for forced policy will be paid first out of insurance impound (if any). Servicer will advance funds to pay remainder of forced policy balance. Servicer will demand payment from borrower, but lender is liable for borrower non-payment.',
                value: 'force_place',
              },
              {
                label: 'Do nothing. Insurance will NOT be paid.',
                value: 'do_nothing',
              },
            ],
          },
          {
            title: 'HOA Impound Shortage',
            description:
              'How should Pixel Servicing handle HOA impound shortage at the time HOA fees are due?',
            name: 'pref_hoa_impound_shortage',
            type: 'radio',
            options: [
              {
                label:
                  'Notify lender in advance. Lender will decide whether or not to advance funds at that time.',
                value: 'lender_notify',
              },
              {
                label:
                  'Withdraw automatically from lender’s bank account to advance and cover shortage.',
                value: 'lender_advance',
              },
              {
                label: 'Do nothing. HOA fees will NOT be paid.',
                value: 'do_nothing',
              },
            ],
          },
          {
            title: 'Impound Cushion',
            description:
              'What should the default impound cushion be for new loans?',
            name: 'impound_cushion',
            type: 'select',
            options: cushionOptions,
            readOnly: isLender,
          },
          {
            title: 'Servicer Penalty Split',
            description:
              'What should the servicer penalty split be for new loans?',
            name: 'servicer_penalty_split',
            type: 'select',
            options: penaltySplitOptions,
            readOnly: isLender,
          },
          {
            title: 'Payment Waterfall',
            name: 'payment_waterfall',
            type: 'paymentWaterfall',
            isHidden: () => isLender,
          },
        ],
      },
      {
        title: 'Lien Holder',
        fields: [
          {
            title: 'Lien Holder Name',
            name: 'lien_holder_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['lienHoldersSettingsOptions', lenderId],
              queryFn: () => {
                if (isLender) {
                  return LenderService.getLenderLienHolders(lenderId);
                }

                return LienHolderService.getLienHolders(lenderId);

                /* return VendorService.getVendors({
                  type: 'Lien holder',
                }); */
              },
              labelKey: 'name',
            },
            tooltip: () =>
              isLender
                ? 'If you note has a lien holder, specify that lien holder here. This will reduce problems with distributing payoff funds'
                : null,
            tooltipSize: 'lg',
          },
          {
            title: 'Recording number',
            name: 'lien_holder_recording_number',
            type: 'text',
            tooltip: () =>
              isLender
                ? "Specify your lien holder's deed recording number. This will reduce mistakes during payoff"
                : null,
          },
        ],
      },
    ],
    [isLender, lenderId]
  );

  return useForm({ fields, onSubmit, values });
};

export default useSettingsForm;
